import { useEffect, useState } from 'react';

import {
  denyNotifyConsent,
  getStoredNotifyConsent,
  grantNotifyConsent,
  subscribeNotifyConsent,
} from 'utils/desktopNotify';

import styles from './DesktopNotifyPrompt.module.scss';

export function DesktopNotifyPrompt() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const sync = () => setVisible(getStoredNotifyConsent() === null);
    sync();
    return subscribeNotifyConsent(sync);
  }, []);

  useEffect(() => {
    document.documentElement.classList.toggle('notify-banner-open', visible);
    return () => document.documentElement.classList.remove('notify-banner-open');
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      className={styles.wrap}
      role='dialog'
      aria-live='polite'
      aria-label='Согласие на уведомления'
    >
      <div className={styles.card}>
        <div className={styles.info}>
          <p className={styles.title}>Уведомления</p>
          <p className={styles.text}>
            Разрешить звук и всплывающие уведомления о новых сообщениях и заявках, пока кабинет
            открыт? Согласие сохраняется в этом браузере.
          </p>
        </div>
        <div className={styles.actions}>
          <button type='button' className={styles.laterBtn} onClick={denyNotifyConsent}>
            Не сейчас
          </button>
          <button
            type='button'
            className={styles.okBtn}
            onClick={() => {
              void grantNotifyConsent();
            }}
          >
            Разрешить
          </button>
        </div>
      </div>
    </div>
  );
}
